import { Box, Typography, Chip, Divider } from '@mui/material';
import { keyframes } from '@mui/system';

interface LibraryItem {
  icon: string;
  iconColor: string;
  title: string;
  tags: { text: string; color: string }[];
  time: string;
  difficulty: string;
}

const track1Data: LibraryItem[] = [
  {
    icon: '📁',
    iconColor: '#3B82F6',
    title: 'Brain Injury Formulation Template',
    tags: [
      { text: 'Resource', color: '#DBEAFE' },
      { text: 'Assessment', color: '#FEF3C7' },
    ],
    time: '20 min',
    difficulty: 'Moderate',
  },
  {
    icon: '👍',
    iconColor: '#10B981',
    title: 'Brain Region Knowledge Reinforcement',
    tags: [
      { text: 'Nudge', color: '#D1FAE5' },
      { text: 'Activity', color: '#E0E7FF' },
    ],
    time: '1 min',
    difficulty: 'Easy',
  },
  {
    icon: '🔔',
    iconColor: '#F59E0B',
    title: 'Compassionate Imagery Exercises',
    tags: [
      { text: 'Reminder', color: '#FEF3C7' },
      { text: 'Activity', color: '#DBEAFE' },
    ],
    time: '15 min',
    difficulty: 'Moderate',
  },
  {
    icon: '📖',
    iconColor: '#8B5CF6',
    title: 'Goal Management Framework (GMF) Journal',
    tags: [
      { text: 'Journal', color: '#EDE9FE' },
      { text: 'Action', color: '#E0E7FF' },
    ],
    time: '5 min',
    difficulty: 'Easy',
  },
  {
    icon: '👍',
    iconColor: '#10B981',
    title: 'Visual Search & Strategy Reflection',
    tags: [
      { text: 'Nudge', color: '#D1FAE5' },
      { text: 'Reflection', color: '#FCE7F3' },
    ],
    time: '5 min',
    difficulty: 'Easy',
  },
  {
    icon: '📊',
    iconColor: '#EC4899',
    title: 'Emotion Thermometer Tracker',
    tags: [{ text: 'Tracker', color: '#FCE7F3' }],
    time: '2 min',
    difficulty: 'Easy',
  },
];

const track2Data: LibraryItem[] = [
  {
    icon: '🔔',
    iconColor: '#F59E0B',
    title: 'PQRST Reading Comprehension Method',
    tags: [
      { text: 'Resource', color: '#DBEAFE' },
      { text: 'Activity', color: '#E0E7FF' },
    ],
    time: '15 min',
    difficulty: 'Moderate',
  },
  {
    icon: '📁',
    iconColor: '#3B82F6',
    title: 'Introduction to Visuospatial Attention',
    tags: [
      { text: 'Resource', color: '#DBEAFE' },
      { text: 'Education', color: '#DBEAFE' },
    ],
    time: '3 min',
    difficulty: 'Easy',
  },
  {
    icon: '📖',
    iconColor: '#8B5CF6',
    title: 'Fatigue Profile — reflective journal',
    tags: [
      { text: 'Journal', color: '#EDE9FE' },
      { text: 'Reflection', color: '#FCE7F3' },
    ],
    time: '5 min',
    difficulty: 'Easy',
  },
  {
    icon: '📊',
    iconColor: '#EC4899',
    title: 'Behavioral Experiment Log',
    tags: [
      { text: 'Tracker', color: '#FCE7F3' },
      { text: 'Monitoring', color: '#FCE7F3' },
    ],
    time: '2 min',
    difficulty: 'Easy',
  },
  {
    icon: '📁',
    iconColor: '#3B82F6',
    title: 'The Memory Palace Technique',
    tags: [
      { text: 'Resource', color: '#DBEAFE' },
      { text: 'Education', color: '#DBEAFE' },
    ],
    time: '5 min',
    difficulty: 'Easy',
  },
  {
    icon: '📖',
    iconColor: '#8B5CF6',
    title: 'Memory Stages Reflection Journal',
    tags: [
      { text: 'Journal', color: '#EDE9FE' },
      { text: 'Reflection', color: '#FCE7F3' },
    ],
    time: '5 min',
    difficulty: 'Easy',
  },
];

const track3Data: LibraryItem[] = [
  {
    icon: '📊',
    iconColor: '#EC4899',
    title: 'Attention Slip Monitor',
    tags: [
      { text: 'Tracker', color: '#FCE7F3' },
      { text: 'Monitoring', color: '#FCE7F3' },
    ],
    time: '2 min',
    difficulty: 'Easy',
  },
  {
    icon: '📁',
    iconColor: '#3B82F6',
    title: 'Executive Functioning Self-Assessment',
    tags: [
      { text: 'Resource', color: '#DBEAFE' },
      { text: 'Assessment', color: '#FEF3C7' },
    ],
    time: '15 min',
    difficulty: 'Moderate',
  },
  {
    icon: '📖',
    iconColor: '#8B5CF6',
    title: 'Identity & Strengths Reflection Journal',
    tags: [
      { text: 'Journal', color: '#EDE9FE' },
      { text: 'Reflection', color: '#FCE7F3' },
    ],
    time: '15 min',
    difficulty: 'Easy',
  },
  {
    icon: '👍',
    iconColor: '#10B981',
    title: 'Cognitive & Emotional Regulation Cue Cards',
    tags: [
      { text: 'Nudge', color: '#D1FAE5' },
      { text: 'Activity', color: '#DBEAFE' },
    ],
    time: '5 min',
    difficulty: 'Easy',
  },
  {
    icon: '📁',
    iconColor: '#3B82F6',
    title: 'Educational Resource: Neurons & Brain',
    tags: [
      { text: 'Resource', color: '#DBEAFE' },
      { text: 'Education', color: '#DBEAFE' },
    ],
    time: '10 min',
    difficulty: 'Easy',
  },
  {
    icon: '📖',
    iconColor: '#8B5CF6',
    title: 'Mood Diary',
    tags: [
      { text: 'Journal', color: '#EDE9FE' },
      { text: 'Monitoring', color: '#FCE7F3' },
    ],
    time: '5 min',
    difficulty: 'Easy',
  },
];

const scrollLeft = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

const scrollRight = keyframes`
  0% { transform: translateX(-50%); }
  100% { transform: translateX(0); }
`;

function LibraryCard({ item }: { item: LibraryItem }) {
  return (
    <Box
      sx={{
        width: 260,
        flexShrink: 0,
        bgcolor: 'white',
        border: '1px solid #e5e7eb',
        borderRadius: 2,
        p: 2,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
      }}
    >
      <Box sx={{ mb: 1 }}>
        <Typography component="span" sx={{ fontSize: 20 }}>
          {item.icon}
        </Typography>
      </Box>
      <Typography
        sx={{
          fontSize: '0.95rem',
          fontWeight: 600,
          mb: 1,
          lineHeight: 1.3,
          minHeight: '2.6em',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
        }}
      >
        {item.title}
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 1.5 }}>
        {item.tags.map((tag, i) => (
          <Chip
            key={i}
            label={tag.text}
            size="small"
            sx={{
              bgcolor: tag.color,
              fontSize: '0.75rem',
              height: 22,
              fontWeight: 500,
            }}
          />
        ))}
      </Box>
      <Divider sx={{ mb: 1 }} />
      <Typography variant="caption" color="text.secondary">
        ⏱️ {item.time} | 🎯 {item.difficulty}
      </Typography>
    </Box>
  );
}

function MarqueeTrack({
  items,
  direction,
  duration,
}: {
  items: LibraryItem[];
  direction: 'left' | 'right';
  duration: number;
}) {
  const doubledItems = [...items, ...items];

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        animation: `${direction === 'left' ? scrollLeft : scrollRight} ${duration}s linear infinite`,
        '&:hover': {
          animationPlayState: 'paused',
        },
      }}
    >
      {doubledItems.map((item, index) => (
        <LibraryCard key={index} item={item} />
      ))}
    </Box>
  );
}

export function LibraryMarquee() {
  return (
    <Box
      sx={{
        width: '100%',
        overflow: 'hidden',
        maskImage: 'linear-gradient(to right, transparent 0%, black 5%, black 95%, transparent 100%)',
        WebkitMaskImage:
          'linear-gradient(to right, transparent 0%, black 5%, black 95%, transparent 100%)',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <MarqueeTrack items={track1Data} direction="left" duration={15} />
        <MarqueeTrack items={track2Data} direction="right" duration={18} />
        <MarqueeTrack items={track3Data} direction="left" duration={13} />
      </Box>
    </Box>
  );
}
